import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

var FormattedTime = function FormattedTime(_ref) {
  var time = _ref.time,
      variant = _ref.variant;
  var Tag = variant || Fragment;
  var momentTime = moment(time, 'hh:mm A');
  return momentTime.isValid() ? React.createElement(Tag, null, momentTime.format('LT')) : React.createElement(React.Fragment, null, "Invalid date");
};

FormattedTime.propTypes = {
  /** time value is required */
  time: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.number]).isRequired,

  /** set the moment component to be variant ('div','string'...) in stead of fragment */
  variant: PropTypes.string
};
export default FormattedTime;